<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>

        <v-card class="text-xs-center">
          <basic-toolbar title="Alocar bolsas"></basic-toolbar>
          <v-card-text>

            <v-layout row wrap justify-center>
              <v-flex xs11>
                <v-layout row wrap justify-space-between>
                  <v-flex xs11 sm5>
                    <v-select
                      label='Bolsa'
                      :items="listaBolsas"
                      v-model="idBolsa"
                      item-text="descricao"
                      item-value="idBolsa"
                      prepend-icon="dashboard"
                      max-height="400"
                      required
                      autocomplete
                      :rules="regrasBasicas" >
                    </v-select>
                  </v-flex>
                  <v-flex xs11 sm3>
                    <c-date-menu
                      label="Data inicial de vigência da bolsa"
                      v-model="bolsa.dtInicio"
                      clearable
                      required
                      :rules="regrasBasicas"
                    ></c-date-menu>
                  </v-flex>
                  <v-flex xs11 sm3>
                    <c-date-menu
                      label="Data final de vigência da bolsa"
                      v-model="bolsa.dtFim"
                      clearable
                      required
                      :rules="regrasBasicas"
                    ></c-date-menu>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>


            <v-layout row wrap>
              <v-spacer></v-spacer>
              <v-flex xs4>
                <v-text-field append-icon="filter_list" label="Filtrar resultados" v-model="search"></v-text-field>
              </v-flex>
            </v-layout>

            <v-data-table
            :headers="headers"
            :items="listaProjetos"
            :search="search"
            :no-data-text="'Nenhum projeto encontrado'"
            must-sort
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :items-per-page="itemsPerPage"
            :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
            >
              <template v-slot:item.titulo="props">
                <router-link :to="{ name: 'ProjetoFormulario', params: { idProjeto: props.item.idProjeto }}">{{ props.item.titulo }}</router-link>
              </template>

              <template v-slot:item.opcoes="props">

                <c-tooltip-btn
                icon="add_box"
                color="green"
                :disabled="!idBolsa || !bolsa.dtInicio || !bolsa.dtFim"
                tooltip="Adicionar uma bolsa a esta ação"
                disabled-tooltip="Selecione uma bolsa e informe as datas"
                @click="adicionarBolsa(props.item.idProjeto)"
                ></c-tooltip-btn>

              </template>

              <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
                Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaProjetos.length }} projetos
              </template>
            </v-data-table>
            <br>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import TootipButton from '@/components/c-tooltip-btn'
  import DataMenu from '@/components/c-date-menu'
  import dates from '@/utils/dates'
  import projetos from '@/utils/projetos'
  import bolsas from '@/utils/bolsas'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    props: ['idProjeto'],
    data: () => ({
      listaBolsas: [],
      bolsa: {},
      idBolsa: undefined,
      formularioValido: false,
      dates: dates,
      pesquisaAvancada: false,
      pesquisa: {
        situacao: [18]
      },
      listaProjetos: [],
      regrasBasicas: [
        (input) => !!input || 'Este campo é obrigatório'
      ],
      search: null,
      sortBy: 'dtCriacao',
      sortDesc: true,
      itemsPerPage: -1,
      opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
      headers: [
        { text: 'Número', align: 'center', value: 'idProjeto' },
        { text: 'Título', align: 'center', value: 'titulo' },
        { text: 'Classificação Primária', align: 'center', value: 'classificacaoPrimaria' },
        { text: 'Classificação Secundária', align: 'center', value: 'classificacaoSecundaria' },
        { text: 'Situação', align: 'center', value: 'situacao' },
        { text: 'Coordenador', align: 'center', value: 'nomeCoordenador' },
        { text: 'Opções', align: 'center', value: 'opcoes' }
      ]
    }),
    computed: {
      ...mapGetters('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX', 'permissaoCriarProjetoExtensao'])
    },
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      limpar () {
        this.pesquisa = { tipoProjeto: 39725 }
      },
      pesquisar () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ações de extensão.' })
        projetos.getConsultaProjetos(this.pesquisa)
        .then(response => {
          this.listaProjetos = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.listaProjetos = []
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ações de extensão.' })
        })
      },
      adicionarBolsa (idProjeto) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Alocando bolsa.' })
        bolsas.putAlocacao(this.idBolsa, idProjeto, 1)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: 'Alocação feita com sucesso!'})
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Alocando bolsa.' })
        })
      },
      truncate (string, limit) {
        if (string.length > limit) return string.substring(0, limit) + '...'
        else return string
      },
      obterClassificacoes: function (itemTabela, aqui, atributo) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificação ' + atributo })
        projetos.getClassificacoesPossiveis(itemTabela)
        .then(response => {
          aqui[atributo] = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificação ' + atributo })
        })
      }
    },
    mounted () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando bolsas.' })
      bolsas.getBolsasGerenciadas()
      .then(response => {
        this.listaBolsas = response.data.slice()
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando bolsas.' })
      })

      // this.obterClassificacoes(90, this, 'listaTipo')
      this.obterClassificacoes(91, this, 'listaSubtipo')
      this.pesquisar()
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip,
      'c-tooltip-btn': TootipButton,
      'c-date-menu': DataMenu
    }
  }
</script>



// WEBPACK FOOTER //
// alocar-bolsa-tabela.vue?50d5cb53